import { _ContentParser, _PdfContentStream, _PdfReference, PdfPath, PdfRotationAngle } from '@syncfusion/ej2-pdf';
import { TextGlyph, TextLine, TextWord } from './text-structure';
import { _TextProcessingMode } from './enum';
import { _decodeEncodedText, _getXObject } from './utils';
import { _PdfTextParser } from './pdf-text-parser';
import { _PdfShapeParser } from './redaction/shape-parser-helper';
var _PdfContentParserHelper = /** @class */ (function () {
    function _PdfContentParserHelper(mode, redaction) {
        this._identityMatrix = [1, 0, 0, 1, 0, 0];
        this._width = 0;
        this._height = 0;
        this._resultantText = '';
        this._textGlyph = [];
        this._textWord = [];
        this._textLine = [];
        this._isContainsRedactionText = false;
        this._yPosition = 0;
        this._xPosition = 0;
        this._parser = new _PdfTextParser();
        if (typeof (mode) !== 'undefined') {
            this._mode = mode;
        }
        if (this._mode === _TextProcessingMode.redaction) {
            this._redaction = redaction;
            this._document = redaction._document;
        }
    }
    _PdfContentParserHelper.prototype._getPageRecordCollection = function (page) {
        var combinedContent = page._combineContent();
        var parser = new _ContentParser(combinedContent);
        var recordCollection = parser._readContent();
        return recordCollection;
    };
    _PdfContentParserHelper.prototype._processTjOperator = function (record, textState, currentFont, page, fontCollection) {
        currentFont = this._parser._getTextFont(fontCollection, textState, this._crossReference);
        var element = '';
        if (record._operator === '"') {
            element = record._operands[2];
        }
        else {
            element = record._operands[0];
        }
        var result; // eslint-disable-line
        var elements; // eslint-disable-line
        var textGlyphs = [];
        var encodedText = [];
        var decodedText = [];
        var updatedText = '';
        var isChangeOperator = false;
        var object; // eslint-disable-line
        var extractedText;
        var text;
        if (this._mode === _TextProcessingMode.textLineExtraction) {
            result = this._parser._getSplitText(element, currentFont, record._splitText);
            object = this._getTextElementsFromTjOperator(result.decodedList, currentFont, textState, page);
            extractedText = object.extractedText;
            text = object.tempString;
            this._setTextLineCollection(text, currentFont, textState, page, extractedText);
        }
        else if (this._mode === _TextProcessingMode.textExtraction) {
            currentFont = this._parser._getTextFont(fontCollection, textState, this._crossReference);
            this._extractTextElement(element, currentFont, record._splitText);
            if (record._operator === "'" || record._operator === '"') { //eslint-disable-line
                this._resultantText += '\r\n';
            }
        }
        else if (this._mode === _TextProcessingMode.redaction) {
            if (this._isContainsRedactionText) {
                var glyphs = [];
                result = this._parser._getSplitText(element, currentFont, record._splitText, true);
                elements = this._getTextElementsFromTjOperator(result.decodedList, currentFont, textState, page, glyphs, result.inputType);
                textGlyphs = elements.textGlyphs;
                decodedText = elements.decodedText;
                encodedText = elements.encodedText;
                updatedText = this._redaction._replacedText(textGlyphs, encodedText, element, decodedText);
                if (updatedText === record._operands[0]) {
                    this._isNotUpdated = true;
                }
                else {
                    isChangeOperator = true;
                }
                return { updatedText: updatedText, isChangeOperator: isChangeOperator };
            }
        }
    };
    _PdfContentParserHelper.prototype._setTextLineCollection = function (text, currentFont, textState, page, extractedText) {
        if (text !== '') {
            var textWord = new TextWord();
            textWord._text = text;
            textWord._glyphs = this._textGlyph;
            var pdfPath_1 = new PdfPath();
            for (var i = 0; i < this._textGlyph.length; i++) {
                pdfPath_1.addRectangle(this._textGlyph[Number.parseInt(i.toString(), 10)]._bounds[0], this._textGlyph[Number.parseInt(i.toString(), 10)]._bounds[1], this._textGlyph[Number.parseInt(i.toString(), 10)]._bounds[2], this._textGlyph[Number.parseInt(i.toString(), 10)]._bounds[3]);
            }
            textWord._bounds = pdfPath_1._getBounds();
            textWord._fontName = currentFont._name;
            textWord._fontStyle = currentFont._fontStyle;
            textWord._fontSize = this._fontSize;
            this._textWord.push(textWord);
            this._height = 0;
        }
        this._width = 0;
        this._textGlyph = [];
        var textLine1 = new TextLine();
        textLine1._text = extractedText;
        textLine1._wordCollection = this._textWord;
        textLine1._fontName = currentFont._name;
        textLine1._fontStyle = currentFont._fontStyle;
        textLine1._fontSize = textState._fontSize;
        textLine1._pageIndex = page._pageIndex;
        var pdfPath = new PdfPath();
        for (var i = 0; i < this._textWord.length; i++) {
            pdfPath.addRectangle(this._textWord[Number.parseInt(i.toString(), 10)]._bounds[0], this._textWord[Number.parseInt(i.toString(), 10)]._bounds[1], this._textWord[Number.parseInt(i.toString(), 10)]._bounds[2], this._textWord[Number.parseInt(i.toString(), 10)]._bounds[3]);
        }
        textLine1._bounds = pdfPath._getBounds();
        this._textLine.push(textLine1);
    };
    _PdfContentParserHelper.prototype._processTJOperator = function (record, textState, currentFont, page, fontCollection) {
        currentFont = this._parser._getTextFont(fontCollection, textState, this._crossReference);
        var element = record._operands[0];
        var result; // eslint-disable-line
        var elements; // eslint-disable-line
        var textGlyphs = [];
        var encodedText = [];
        var updatedText = '';
        var decodedText = [];
        var isChangeOperator = false;
        currentFont = this._parser._getTextFont(fontCollection, textState, this._crossReference);
        if (this._mode === _TextProcessingMode.textLineExtraction) {
            result = this._parser._getSplitText(element[0], currentFont, record._splitText);
            var object = this._getTextElementsFromTJOperator(result.decodedList, currentFont, textState, page); // eslint-disable-line
            this._setTextLineCollection(object.tempString, currentFont, textState, page, object.extractedText);
        }
        else if (this._mode === _TextProcessingMode.textExtraction) {
            currentFont = this._parser._getTextFont(fontCollection, textState, this._crossReference);
            this._extractTextElement(element, currentFont, record._splitText);
            if (record._operator === "'") { //eslint-disable-line
                this._resultantText += '\r\n';
            }
        }
        else if (this._mode === _TextProcessingMode.redaction) {
            if (this._isContainsRedactionText) {
                var glyphs = [];
                result = this._parser._getSplitText(element[0], currentFont, record._splitText, true);
                elements = this._getTextElementsFromTJOperator(result.decodedList, currentFont, textState, page, glyphs, result.inputType);
                textGlyphs = elements.textGlyphs;
                decodedText = elements.decodedText;
                encodedText = elements.encodeText;
                updatedText = this._redaction._replacedText(textGlyphs, encodedText, element, decodedText);
                if (updatedText === element) {
                    this._isNotUpdated = true;
                }
                else {
                    isChangeOperator = true;
                }
            }
        }
        return { updatedText: updatedText, isChangeOperator: isChangeOperator };
    };
    _PdfContentParserHelper.prototype._processSingleQuoteOperator = function (record, textState, currentFont, page, fontCollection) {
        textState._carriageReturn();
        var result = this._processTjOperator(record, textState, currentFont, page, fontCollection); // eslint-disable-line
        if (typeof result === 'object' && result !== null) {
            var updatedText = result.updatedText, isChangeOperator = result.isChangeOperator;
            return { updatedText: updatedText, isChangeOperator: isChangeOperator };
        }
    };
    _PdfContentParserHelper.prototype._processDoubleQuoteOperator = function (record, textState, currentFont, page, fontCollection) {
        textState._wordSpacing = Number(record._operands[0]);
        textState._charSpacing = Number(record._operands[1]);
        textState._carriageReturn();
        var result = this._processTjOperator(record, textState, currentFont, page, fontCollection); // eslint-disable-line
        if (typeof result === 'object' && result !== null) {
            var updatedText = result.updatedText, isChangeOperator = result.isChangeOperator;
            return { updatedText: updatedText, isChangeOperator: isChangeOperator };
        }
    };
    _PdfContentParserHelper.prototype._processRecordCollection = function (recordCollection, page, fontCollection, xObjectCollection, graphicState) {
        var textState;
        var red = 0;
        var green = 0;
        var blue = 0;
        var updatedText = '';
        var parser;
        var skipUntil = -1;
        var stream = new _PdfContentStream([]);
        for (var i = 0; i < recordCollection.length; i++) {
            var record = recordCollection[Number.parseInt(i.toString(), 10)];
            var token = record._operator;
            var element = record._operands;
            this._parser._processCommand(token, element, graphicState);
            textState = graphicState._state;
            var isChangeOperator = false;
            var currentFont = void 0;
            var currentIndex = i;
            switch (token) {
                case 'Tm':
                    if (this._mode !== _TextProcessingMode.textExtraction) {
                        this._parser._setTextMatrix(element, textState);
                    }
                    if (this._mode === _TextProcessingMode.redaction) {
                        var x = textState._textMatrix[4];
                        var y = textState._textMatrix[5];
                        if (this._parser._isFoundText(x, y, page, this._redaction._redactionRegion)) {
                            this._isContainsRedactionText = true;
                        }
                        if (recordCollection.length !== i + 1 && !this._isContainsRedactionText) {
                            this._isContainsRedactionText = true;
                        }
                        if (!this._isContainsRedactionText && page.size[1] === y) {
                            this._isContainsRedactionText = true;
                        }
                    }
                    break;
                case 'cm':
                    {
                        if (this._mode === _TextProcessingMode.redaction) {
                            var x = parseFloat(element[4]);
                            var y = parseFloat(element[5]);
                            if (this._parser._isFoundText(x, y, page, this._redaction._redactionRegion)) {
                                this._isContainsRedactionText = true;
                            }
                        }
                    }
                    break;
                case 'BT':
                    if (this._mode !== _TextProcessingMode.textExtraction) {
                        this._parser._beginText(textState, this._identityMatrix);
                    }
                    break;
                case 'ET':
                    if (this._mode === _TextProcessingMode.textExtraction) {
                        this._resultantText += '\r\n';
                    }
                    else if (this._mode === _TextProcessingMode.redaction) {
                        this._isContainsRedactionText = false;
                        this._xPosition = 0;
                        this._yPosition = 0;
                    }
                    break;
                case 'Tf':
                    this._parser._setFont(element, textState);
                    break;
                case 'Tc':
                    if (this._mode !== _TextProcessingMode.textExtraction) {
                        this._parser._setCharSpacing(element, textState);
                    }
                    break;
                case 'Tw':
                    if (this._mode !== _TextProcessingMode.textExtraction) {
                        this._parser._setWordSpacing(element, textState);
                    }
                    break;
                case 'Tz':
                    if (this._mode !== _TextProcessingMode.textExtraction) {
                        this._parser._setTextHorizontalScale(element, textState);
                    }
                    break;
                case 'TL':
                    if (this._mode !== _TextProcessingMode.textExtraction) {
                        this._parser._updateTextLeading(element, textState);
                    }
                    break;
                case 'Td':
                    if (this._mode !== _TextProcessingMode.textExtraction) {
                        this._parser._moveTextPlacement(element, textState);
                    }
                    if (this._mode === _TextProcessingMode.redaction) {
                        this._xPosition = this._xPosition + parseFloat(element[0]);
                        this._yPosition = this._yPosition - parseFloat(element[1]);
                        if (this._parser._isFoundText(this._xPosition, this._yPosition, page, this._redaction._redactionRegion)) {
                            this._isContainsRedactionText = true;
                        }
                        if (recordCollection.length !== i + 1 && !this._isContainsRedactionText) {
                            var temp = recordCollection[i + 1]._operator;
                            if (temp === 'Tj' || temp === 'TJ' || temp === '"' || temp === "'") { // eslint-disable-line
                                this._isContainsRedactionText = true;
                            }
                        }
                    }
                    break;
                case 'TD':
                    if (this._mode !== _TextProcessingMode.textExtraction) {
                        this._parser._moveTextPlacementAndSetLeading(element, textState);
                    }
                    if (this._mode === _TextProcessingMode.redaction) {
                        this._xPosition = this._xPosition + parseFloat(element[0]);
                        this._yPosition = this._yPosition - parseFloat(element[1]);
                        if (this._parser._isFoundText(this._xPosition, this._yPosition, page, this._redaction._redactionRegion)) {
                            this._isContainsRedactionText = true;
                        }
                        if (recordCollection.length !== i + 1 && !this._isContainsRedactionText) {
                            var temp = recordCollection[i + 1]._operator;
                            if (temp === 'Tj' || temp === 'TJ' || temp === '"' || temp === "'") { // eslint-disable-line
                                this._isContainsRedactionText = true;
                            }
                        }
                    }
                    break;
                case 'Ts':
                    if (this._mode !== _TextProcessingMode.textExtraction) {
                        this._parser._setTextRise(element, textState);
                    }
                    break;
                case 'Tj':
                    {
                        var result = this._processTjOperator(record, textState, currentFont, page, fontCollection); // eslint-disable-line
                        if (record._operands) {
                            if (typeof result === 'object' && result !== null) {
                                updatedText = result.updatedText;
                                isChangeOperator = result.isChangeOperator;
                            }
                        }
                        break;
                    }
                case 'TJ':
                    {
                        var result = this._processTJOperator(record, textState, currentFont, page, fontCollection); // eslint-disable-line
                        if (typeof result === 'object' && result !== null) {
                            updatedText = result.updatedText;
                            isChangeOperator = result.isChangeOperator;
                        }
                        break;
                    }
                case "'": // eslint-disable-line
                    {
                        var result = this._processSingleQuoteOperator(record, textState, currentFont, page, // eslint-disable-line 
                        fontCollection);
                        if (typeof result === 'object' && result !== null) {
                            updatedText = result.updatedText;
                            isChangeOperator = result.isChangeOperator;
                        }
                        break;
                    }
                case '"':
                    {
                        var result = this._processDoubleQuoteOperator(record, textState, currentFont, page, // eslint-disable-line
                        fontCollection);
                        if (typeof result === 'object' && result !== null) {
                            updatedText = result.updatedText;
                            isChangeOperator = result.isChangeOperator;
                        }
                        break;
                    }
                case 'T*':
                    if (this._mode === _TextProcessingMode.textExtraction) {
                        this._resultantText += '\r\n';
                    }
                    else {
                        this._parser._setNewLineWithLeading(textState);
                    }
                    break;
                case 'Do':
                    {
                        var xobject = element[0].replace('/', '');
                        if (xObjectCollection.has(xobject)) {
                            var base = xObjectCollection.get(xobject); //eslint-disable-line
                            if (base) {
                                if (this._mode === _TextProcessingMode.textExtraction || this._mode === _TextProcessingMode.textLineExtraction) {
                                    _getXObject(element, page, xObjectCollection, this, this._mode, graphicState);
                                }
                                else if (this._mode === _TextProcessingMode.redaction) {
                                    var pdfStream = _getXObject(element, page, xObjectCollection, this, this._mode, graphicState); // eslint-disable-line
                                    delete base.dictionary._map.Length;
                                    delete base.dictionary._map.Filter;
                                    base.dictionary.update('Length', pdfStream.length);
                                    pdfStream.dictionary = base.dictionary;
                                    pdfStream.dictionary._updated = true;
                                    var objectId = base.dictionary.objId; // eslint-disable-line
                                    var strParts = objectId.split(' ');
                                    var reference = _PdfReference.get(Number(strParts[0]), Number(strParts[1]));
                                    this._document._crossReference._cacheMap.set(reference, pdfStream);
                                }
                            }
                        }
                        break;
                    }
                case 'RG':
                case 'k':
                case 'g':
                case 'rg':
                    red = Number(element[0]);
                    green = Number(element[1]);
                    blue = Number(element[2]);
                    textState._textColor = [red, green, blue];
                    break;
                case 're':
                    {
                        parser = new _PdfShapeParser();
                        var records = parser._processRectangle(recordCollection, i, element);
                        if (record && records.length > 0) {
                            recordCollection.splice.apply(recordCollection, [i--, 1].concat(records));
                        }
                        break;
                    }
                case 'm':
                    parser = new _PdfShapeParser();
                    skipUntil = parser._findRedactPath(recordCollection, i, page, this._redaction, this._mode, stream);
                    if (skipUntil !== -1) {
                        i = skipUntil;
                    }
                    break;
            }
            if (this._mode === _TextProcessingMode.redaction && currentIndex === i) {
                if (!isChangeOperator) {
                    updatedText = '';
                }
                this._redaction._optimizeContent(recordCollection, i, updatedText, stream);
                isChangeOperator = false;
            }
        }
        if (this._mode === _TextProcessingMode.redaction) {
            stream.write('\r\n');
            return stream;
        }
        else if (this._mode === _TextProcessingMode.textExtraction) {
            return this._resultantText;
        }
        else if (this._mode === _TextProcessingMode.textLineExtraction) {
            return this._textLine;
        }
        return;
    };
    _PdfContentParserHelper.prototype._extractTextElement = function (elements, currentFont, inputText) {
        var decodedText = _decodeEncodedText(elements, currentFont, inputText);
        this._resultantText += decodedText;
    };
    _PdfContentParserHelper.prototype._getTextElementsFromTjOperator = function (decodedList, currentFont, textState, page, textGlyphs, inputType) {
        this._textWord = [];
        var tempString = '';
        var text = decodedList;
        var previousRect = { x: 0, y: 0, width: 0, height: 0 };
        var decodedText = [];
        var encodedText = [];
        var extractedText = '';
        var index = 0;
        var hex = [];
        if (text.length > 0) {
            if (typeof (textGlyphs) !== 'undefined') {
                if (inputType[0] !== ' ') {
                    hex = this._parser._splitHexString(inputType[0]);
                }
                var result = this._parser._getTextContentItem(currentFont, text[0], 0, textState, page, tempString, previousRect, extractedText, this, textGlyphs, hex, index, encodedText); // eslint-disable-line
                decodedText[0] = '(' + result.extractedText + ')';
                encodedText = result.encodedText;
                extractedText = result.extractedText;
                return { textGlyphs: textGlyphs, decodedText: decodedText, encodedText: encodedText };
            }
            else {
                var result = this._parser._getTextContentItem(currentFont, text[0], 0, textState, page, tempString, previousRect, extractedText, this); //eslint-disable-line
                tempString = result.tempString;
                extractedText = result.extractedText;
                this._fontSize = result.fontSize;
                return { tempString: tempString, extractedText: extractedText };
            }
        }
    };
    _PdfContentParserHelper.prototype._getTextElementsFromTJOperator = function (decodedList, currentFont, textState, page, textGlyphs, inputType) {
        var textValues = [];
        this._textWord = [];
        var tempString = '';
        textValues = decodedList;
        var iszerspace = false;
        var text = '';
        var str = '';
        var previousRect = { x: 0, y: 0, width: 0, height: 0 };
        var decodedText = [];
        var encodedText = [];
        var index = 0;
        var i = 0;
        var hex = [];
        var extractedText = '';
        var spaceFactor = ((currentFont._vertical ? 1 : -1) * textState._fontSize) / 1000;
        for (var j = 0; j < textValues.length; j++) {
            var word = textValues[Number.parseInt(j.toString(), 10)];
            var digit = Number(word); // eslint-disable-line
            if (digit || digit === 0) {
                if (typeof (textGlyphs) !== 'undefined') {
                    if (j > 0 && inputType[j - 1] !== ' ') {
                        hex = this._parser._splitHexString(inputType[j - 1]);
                    }
                    var result = this._parser._getTextContentItem(currentFont, text, digit * spaceFactor, textState, page, tempString, previousRect, extractedText, this, textGlyphs, hex, index, encodedText); // eslint-disable-line
                    textGlyphs = result.textGlyphs;
                    extractedText = result.extractedText;
                    encodedText = result.encodedText;
                    index = result.index;
                    extractedText = '';
                    decodedText[i++] = '(' + result.extractedText + ')';
                    decodedText[i++] = word;
                }
                else {
                    var result = this._parser._getTextContentItem(currentFont, text, digit * spaceFactor, textState, page, tempString, previousRect, extractedText, this); // eslint-disable-line
                    tempString = result.tempString;
                    extractedText = result.extractedText;
                    this._fontSize = result.fontSize;
                    previousRect = result.previousRect;
                }
            }
            else if (digit !== 0) {
                text = word;
                if (iszerspace) {
                    text = str + text;
                    iszerspace = false;
                }
            }
            else {
                iszerspace = true;
                str = text;
            }
        }
        if (typeof (textGlyphs) !== 'undefined') {
            if (inputType[textValues.length - 1] !== ' ') {
                hex = this._parser._splitHexString(inputType[textValues.length - 1]);
            }
            var result = this._parser._getTextContentItem(currentFont, text, 0, textState, page, // eslint-disable-line
            tempString, previousRect, extractedText, this, textGlyphs, hex, index, encodedText);
            decodedText[Number.parseInt(i.toString(), 10)] = '(' + result.extractedText + ')';
            var encodeText = result.encodedText;
            return { textGlyphs: textGlyphs, decodedText: decodedText, encodeText: encodeText };
        }
        else {
            var result = this._parser._getTextContentItem(currentFont, text, 0, textState, page, // eslint-disable-line
            tempString, previousRect, extractedText, this);
            tempString = result.tempString;
            extractedText = result.extractedText;
            this._fontSize = result.fontSize;
            return { tempString: tempString, extractedText: extractedText };
        }
    };
    _PdfContentParserHelper.prototype._splitWords = function (glyph, tempString, fontName, fontStyle, page, rotation, textColor, fontSize, textBounds, previousRect) {
        var _this = this;
        var isSpace = false;
        if (/\s/.test(glyph)) {
            isSpace = true;
        }
        var currentRect = textBounds; //eslint-disable-line
        var addTextWord = function (text, glyphs, width) {
            var textWord = new TextWord();
            textWord._text = text;
            textWord._glyphs = glyphs;
            var pdfPath = new PdfPath();
            for (var i = 0; i < glyphs.length; i++) {
                pdfPath.addRectangle(glyphs[Number.parseInt(i.toString(), 10)]._bounds[0], glyphs[Number.parseInt(i.toString(), 10)]._bounds[1], glyphs[Number.parseInt(i.toString(), 10)]._bounds[2], glyphs[Number.parseInt(i.toString(), 10)]._bounds[3]);
            }
            textWord._bounds = pdfPath._getBounds();
            textWord._fontName = fontName;
            textWord._fontStyle = fontStyle;
            textWord._fontSize = fontSize;
            _this._textWord.push(textWord);
        };
        if (isSpace) {
            if (tempString) {
                if (page.rotation === PdfRotationAngle.angle90 || page.rotation === PdfRotationAngle.angle270 || rotation === 90) {
                    addTextWord(tempString, this._textGlyph, this._height);
                }
                else {
                    addTextWord(tempString, this._textGlyph, this._width);
                }
                this._textGlyph = [];
                tempString = '';
            }
            var textGlyph = new TextGlyph();
            textGlyph._text = glyph;
            textGlyph._bounds = [currentRect.x, currentRect.y, currentRect.width, currentRect.height];
            textGlyph._fontName = fontName;
            textGlyph._fontStyle = fontStyle;
            textGlyph._fontSize = fontSize;
            textGlyph._color = textColor;
            if (page.rotation !== PdfRotationAngle.angle0) {
                textGlyph._isRotated = true;
            }
            else {
                textGlyph._isRotated = false;
            }
            this._textGlyph.push(textGlyph);
            if (page.rotation === PdfRotationAngle.angle90 || page.rotation === PdfRotationAngle.angle270 || rotation === 90) {
                addTextWord(glyph, this._textGlyph, currentRect.height);
            }
            else {
                addTextWord(glyph, this._textGlyph, currentRect.width);
            }
            this._width = 0;
            this._height = 0;
            this._textGlyph = [];
            previousRect = null;
        }
        else if (previousRect !== null && previousRect.width > 0) {
            var spacingFactor = currentRect.height * 0.07;
            if (spacingFactor < 2) {
                spacingFactor = 2;
            }
            var difference = void 0;
            if (page.rotation === PdfRotationAngle.angle90) {
                difference = previousRect.y + previousRect.height - currentRect.y;
            }
            else if (page.rotation === PdfRotationAngle.angle270 || rotation === 90) {
                difference = currentRect.y + currentRect.height - previousRect.y;
            }
            else if (page.rotation === PdfRotationAngle.angle180) {
                difference = currentRect.x + currentRect.width - previousRect.x;
            }
            else {
                difference = previousRect.x + previousRect.width - currentRect.x;
            }
            if (difference > 0) {
                if (spacingFactor === 2) {
                    spacingFactor = 2.5;
                }
            }
            if (Math.abs(difference) > spacingFactor) {
                if (page.rotation === PdfRotationAngle.angle90 || page.rotation === PdfRotationAngle.angle270) {
                    addTextWord(tempString, this._textGlyph, this._height);
                }
                else {
                    addTextWord(tempString, this._textGlyph, this._width);
                }
                this._width = 0;
                this._height = 0;
                this._textGlyph = [];
                tempString = '';
                previousRect = { x: 0, y: 0, width: 0, height: 0 };
            }
        }
        if (!isSpace) {
            var textGlyph = new TextGlyph();
            textGlyph._text = glyph;
            textGlyph._bounds = [currentRect.x, currentRect.y, currentRect.width, currentRect.height];
            textGlyph._fontName = fontName;
            textGlyph._fontStyle = fontStyle;
            textGlyph._fontSize = fontSize;
            textGlyph._color = textColor;
            if (page.rotation !== PdfRotationAngle.angle0) {
                textGlyph._isRotated = true;
            }
            else {
                textGlyph._isRotated = false;
            }
            textGlyph._isRotated = false;
            this._textGlyph.push(textGlyph);
            if (page.rotation === PdfRotationAngle.angle90 || page.rotation === PdfRotationAngle.angle270 || rotation === 90) {
                this._height += currentRect.height;
            }
            else {
                this._width += currentRect.width;
            }
            tempString += glyph;
        }
        return { tempString: tempString, previousRect: previousRect };
    };
    return _PdfContentParserHelper;
}());
export { _PdfContentParserHelper };
